module.exports = __webpack_public_path__ + "media/images/emblems/Schoefflisdorf-blazon-6d82a95009e2e56f190db413db5f915d.svg";